import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[var(--lc-bg)] lc-dots grid place-items-center px-4">
      <div className="w-full max-w-md bg-white rounded-3xl border border-[var(--lc-border)] shadow-xl p-10 text-center" data-testid="payment-cancel-card">
        <div className="w-16 h-16 mx-auto grid place-items-center rounded-full bg-[var(--lc-secondary)]/15">
          <XCircle className="w-10 h-10 text-[var(--lc-secondary)]" />
        </div>
        <h1 className="mt-5 font-display font-extrabold text-2xl text-[var(--lc-ink)]">
          Pago cancelado
        </h1>
        <p className="text-[var(--lc-slate)] mt-2">
          Tu carrito sigue guardado. Puedes finalizar la compra cuando quieras.
        </p>
        <Link
          to="/"
          className="mt-7 inline-block rounded-full bg-[var(--lc-primary)] text-white px-8 py-3.5 font-display font-extrabold transition-transform hover:-translate-y-1 shadow-[0_10px_20px_-4px_rgba(14,165,233,0.45)]"
        >
          Volver a la tienda
        </Link>
      </div>
    </div>
  );
}
